import TextureTitle from "../ui/TextureTitle";
import ShadowTitle from "../ui/ShadowTitle";
import classNames from "classnames";
import TicketRegisterForm from "./TicketRegisterForm";

export default function RegisterForm() {
  const detailsClass = classNames("mb-20");
  const titleClass = classNames("flex flex-col items-center");
  const subTitleClass = classNames(
    "block md:flex font-bold text-2xl md:text-4xl mt-6 justify-center text-center"
  );
  return (
    <div className="mx-auto max-w-screen-md px-4 mt-16 mb-48">
      <div className={detailsClass}>
        <div className="hidden md:block">
          <div className={titleClass}>
            <TextureTitle title="React Day" />
            <TextureTitle title="Bangalore" />
          </div>
        </div>
        <div className="block md:hidden">
          <div className={titleClass}>
            <ShadowTitle className="mb-6">React Day</ShadowTitle>
            <ShadowTitle>Bangalore</ShadowTitle>
          </div>
        </div>
        <div className={subTitleClass}>
          <p>June 8-9, 2022</p>
          <p className="mx-10 hidden md:block">|</p>
          <p>Remote</p>
        </div>
      </div>
      <TicketRegisterForm />
    </div>
  );
}
